<template slot="navbar-menu">
   <navbar type="primary" class="z-index-high">
      <a class="navbar-brand" href="/">
         <img class="logo-brand" src="img/brand_sanchopan.png" alt="Logotipo Sanchopan">
      </a>
      <template slot="navbar-menu">
         <li class="nav-item">
            <a class="nav-link" @click="handleClickNavLink($event)" href="/quienessomos">¿Quiénes somos?</a>
         </li>
         <!-- <li class="nav-item">
            <a class="nav-link" @click="handleClickNavLink($event)" href="/#/quienessomos">¿Quiénes somos?</a>
         </li> -->
         <li class="nav-item">
            <a class="nav-link" href="/productos">Productos</a>
         </li>
         <li class="nav-item">
            <a class="nav-link" href="/contactenos">Contáctenos</a>
         </li>
         <drop-down tag="li" class="nav-item" title="Servicios web">
            <a class="dropdown-item" href="/login">Pedidos</a>
         </drop-down>
      </template>
   </navbar>
</template>

<script>
   import {
      DropDown,
      NavbarToggleButton,
      Navbar,
      NavLink
   } from '@/components';

   export default {
      name: 'my-navbar',
      components: {
         Navbar,
         DropDown,
         NavbarToggleButton,
         NavLink
      },
      methods: {
         handleClickNavLink(componente) {
            console.log(componente)
         }
      }
   }
</script>

<style>
</style>